export const copy = css`
  max-width: ${p => p.theme.measure3};
  line-height: ${p => p.theme.lh2};
`

///////////////////////////////////////////////////////////////////////////////////

import { css } from 'styled-components'
